import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { IDefaultError } from '../../types';
import { LabelValue } from '../../../types/common';
import { getClientPortalCompanies } from '../../../services/ticketTemplates';

export const ThunkClientPortalCompanies = createAsyncThunk<
  LabelValue[],
  undefined,
  { rejectValue: IDefaultError }
>(`${storeResources.TICKETS}/clientPortalCompanies`, () =>
  getClientPortalCompanies().then(res => res.data),
);
